'use strict';

angular.module('app').directive('programmeTheme', function (programmes)
{
    return {
        restrict: 'A',
        link: function(scope, element)
        {
            programmes.onThemeChanged(function (theme)
            {
                element.addClass('theme-' + theme);
            });
        }
    };
});
